<div class="container col-xxl-8 px-4 py-2">
  <div class="row flex-lg-row-reverse align-items-center g-5 py-5">
    <div class="col-10 col-sm-8 col-lg-6">
      <img src="assets/img/imgHero/img2.jpg" class="d-block mx-lg-auto img-fluid" alt="Imagen MediLink" width="700" height="500" loading="lazy">
    </div>
    <div class="col-lg-6">
<!--      <p class="fs-5 lh-1 text-secondary" >Equipo humano con sólida experiencia</p>-->
      <h1 class="fs-1  " style="color: var(--secondary-color)">Somos un <br> <span class="fw-bolder">
        equipo humano
      </span></h1>
      <p class="fs-4 fw-medium text-secondary">con una sólida trayectoria en servicios de salud ambulatorios e integrales.</p>
      <div class="d-md-flex justify-content-md-start">
        <button  routerLink="/nosotros"  class="card-link fs-6 text-light textPrimaryColor  ">Conócenos <i class="bi bi-arrow-up-right-circle-fill"></i></button>
      </div>
    </div>
  </div>
</div>
